var shoppingCart = "https://shopfront-cdn.tekoapis.com/static/8ef484d2d38f9da8.svg";

export { shoppingCart as default };
